import { render, staticRenderFns } from "./WalletBannerBonus.vue?vue&type=template&id=5d9bbba4&"
import script from "./WalletBannerBonus.vue?vue&type=script&lang=js&"
export * from "./WalletBannerBonus.vue?vue&type=script&lang=js&"
import style0 from "./WalletBannerBonus.vue?vue&type=style&index=0&id=5d9bbba4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports